module.exports = __webpack_public_path__ + "static/media/exploded_SmallStellatedDodecahedron.bfc5b655.gif";